(function (global, factory) {
  'use strict';

  if (typeof define === 'function' && define.amd) {
    define([], () => {
      global.StringHelper = factory(global);
      return global.StringHelper;
    });
  } else if (typeof exports === 'object') {
    const handler = factory(global);
    global.StringHelper = handler;
    module.exports = handler;
  } else {
    global.StringHelper = factory(global);
  }
}(typeof window !== 'undefined' ? window : {}, () => {
  'use strict';

  /**
   * Capitalizes the first letter of a string.
   * @param {string} str - The string to capitalize.
   * @returns {string} The capitalized string.
   */
  function capitalizeFirstLetter(str) {
    if (str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
    return '';
  }

  /**
   * Normalizes spaces in a string by replacing multiple spaces with a single space and trimming.
   * @param {string} text - The text to normalize.
   * @returns {string} The normalized text.
   */
  function normalizeSpaces(text) {
    if (!text) {
      return '';
    }

    return text.replace(/\s+/g, ' ').trim();
  }

  return {
    capitalizeFirstLetter,
    normalizeSpaces
  };
}));
